import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

export type JiraPopKind = 'injection' | 'reception';

export interface JiraPopOption {
  label: string;
  value: string;
  kind: JiraPopKind;
  id?: string;
}

export interface BwJiraIssueText {
  subject: string;
  description: string;
}

@Injectable()
export class JiraService {

  constructor(private http: HttpClient) {
  }

  createJiraIssue(jiraIssueData: any): Observable<any> {
    return this.http.post<any>(environment.baseUrlWs + '/api/create-jira-issues', jiraIssueData);
  }

  buildBwIssueText(
    bundleName: string,
    contractReferences: string[],
    popOptions: JiraPopOption[],
    selectedPopValues: string[],
    selectedCrossConnects: string[],
    commentHtml: string
  ): BwJiraIssueText {

    const selected = selectedPopValues || [];
    const labelsOfKind = (kind: JiraPopKind) => (popOptions || [])
      .filter(option => option.kind === kind && selected.includes(option.value))
      .map(option => option.label);

    const injectionPops = labelsOfKind('injection');
    const receptionPops = labelsOfKind('reception');
    const crossConnects = selectedCrossConnects || [];
    const impactedEtrees = (contractReferences || []).join(', ');

    let description = `*Impacted E-Trees:* ${impactedEtrees}\n`;
    if (injectionPops.length > 0) {
      description += `Injection POP: ${injectionPops.join(', ')}\n`;
    }
    if (receptionPops.length > 0) {
      description += `Reception POP: ${receptionPops.join(', ')}\n`;
    }
    if (crossConnects.length > 0) {
      description += `Impacted XCO: ${crossConnects.join(', ')}\n`;
    }
    description += `*Customer addl comment*:\n${commentHtml || ''}`;

    return {
      subject: `Issue impacting [${bundleName}]: E-Tree [${impactedEtrees}]`,
      description: this.htmlToPlainText(description)
    };
  }

  private htmlToPlainText(html: string): string {
    return this.decodeHtmlEntities(
      html
        .replace(/<\/p>/g, '\n')
        .replace(/<br\s*\/?>/g, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
    ).replace(/\u00a0/g, ' ').trim();
  }

  private decodeHtmlEntities(text: string): string {
    const named: { [entity: string]: string } = {
      amp: '&', lt: '<', gt: '>', quot: '"', apos: '\'', nbsp: ' '
    };
    return text.replace(/&(#x[0-9a-f]+|#\d+|[a-z][a-z0-9]*);/gi, (match, entity: string) => {
      const key = entity.toLowerCase();
      if (key.charAt(0) === '#') {
        const code = key.charAt(1) === 'x'
          ? parseInt(key.substring(2), 16)
          : parseInt(key.substring(1), 10);
        return isNaN(code) || code <= 0 || code > 0x10ffff ? match : String.fromCodePoint(code);
      }
      return named.hasOwnProperty(key) ? named[key] : match;
    });
  }
}
